import { useState } from 'react'
import { Copy, Check } from 'lucide-react'

interface CopyImageButtonProps {
  onCopy: () => Promise<void>
  disabled?: boolean
  className?: string
}

export default function CopyImageButton({ onCopy, disabled, className = '' }: CopyImageButtonProps) {
  const [copied, setCopied] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = async () => {
    if (disabled || isLoading) return

    setIsLoading(true)
    try {
      await onCopy()
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (error) {
      console.error('Copy failed:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled || isLoading}
      className={`btn btn-ghost ${className}`}
      aria-label={copied ? 'Image copied' : 'Copy image to clipboard'}
    >
      {copied ? (
        <>
          <Check className="w-4 h-4" />
          Copied!
        </>
      ) : (
        <>
          <Copy className="w-4 h-4" />
          {isLoading ? 'Copying...' : 'Copy Image'}
        </>
      )}
    </button>
  )
}
